import { STORE_NAME } from '../config'

const markets = [
  {
    name: 'FMCG & Retail Distribution',
    text: 'Shelf-ready goods, branded lines and own-label supply for chains and independents.',
    image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=800&q=80'
  },
  {
    name: 'Food & Beverage Manufacturing',
    text: 'Oils, sugars, grains and functional ingredients delivered to production schedules.',
    image: 'https://images.unsplash.com/photo-1556216555-becc1cbd8b23?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=NHwxMjA3fDA%3D'
  },
  {
    name: 'HoReCa',
    text: 'Wholesale formats and consistent supply for hotels, restaurants and catering groups.',
    image: 'https://images.unsplash.com/photo-1536236502598-7dd171f8e852?q=80&w=387&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=NHwxMjA3fDA%3D'
  },
  {
    name: 'Agriculture & Cooperatives',
    text: 'Fertilisers, seeds and crop inputs at cooperative and commercial-farm volumes.',
    image: 'https://images.unsplash.com/photo-1783917329102-5159c219c5d9?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=NHwxMjA3fDA%3D'
  },
  {
    name: 'Wholesalers & Importers',
    text: 'Multi-origin consolidation and re-export support for regional trading houses.',
    image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=800&q=80'
  },
  {
    name: 'Logistics & Port Operations',
    text: 'Port-to-door freight coordination, customs documentation and bonded warehousing partners.',
    image: 'https://images.unsplash.com/photo-1635851801927-44c4d1c555af?q=80&w=873&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=NHwxMjA3fDA%3D'
  },
  {
    name: 'Import & Export of Consumer and Industrial Goods',
    text: 'Branded FMCG, household lines and finished industrial goods consolidated, documented and shipped for distributors and trading partners worldwide.',
    image: 'https://images.unsplash.com/photo-1675860094441-5127d5b05820?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=NHwxMjA3fDA%3D'
  },
  {
    name: 'Supply of Industrial & Commercial Commodities',
    text: 'Raw and semi-processed commodities — metals, agricultural bulk and industrial inputs — supplied to manufacturers, processors and commercial buyers at contract volumes.',
    image: 'https://images.unsplash.com/photo-1516297702292-c919b6adea0c?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=NHwxMjA3fDA%3D'
  },
  {
    name: 'Mining, Metals & Chemical Industry',
    text: 'Copper, aluminium, ores and industrial chemicals for smelters, refineries and processing plants — with assay reports and safety documentation.',
    image: 'https://images.unsplash.com/photo-1523848309072-c199db53f137?auto=format&fit=crop&w=800&q=80'
  }
]

export function MarketsGrid() {
  return (
    <section className="bg-brand-shell px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <span className="mb-3 inline-block rounded-full border border-brand-gold/40 bg-white px-3 py-1 text-xs font-semibold uppercase tracking-widest text-brand-navy">
          Industries
        </span>
        <h2 className="heading-accent font-display text-2xl font-bold text-brand-ink sm:text-3xl">
          Markets we serve
        </h2>
        <p className="mt-4 max-w-2xl text-brand-slate">
          From supermarkets to smelters — {STORE_NAME} customers span food, agriculture, metals,
          chemicals and industrial supply chains, from single-site retailers to multi-country import groups.
        </p>
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {markets.map((m) => (
            <div key={m.name} className="card-lift group overflow-hidden rounded-2xl bg-white shadow-card">
              <div className="relative h-40 overflow-hidden">
                <img
                  src={m.image}
                  alt={m.name}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <h3 className="font-display text-lg font-semibold text-brand-ink">{m.name}</h3>
                <p className="mt-2 text-sm leading-relaxed text-brand-slate">{m.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
